import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import products from "../../data/products";

const FeaturedProducts = () => {
    const latestProducts = [...products].slice(-4).reverse();

    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-6">

                {/* Heading */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-12"
                >
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                        Featured Products
                    </h2>

                    <p className="mt-4 text-gray-600">
                        Quality healthcare equipment selected for comfort and reliability.
                    </p>
                </motion.div>


                {/* Products */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {latestProducts.map((product, index) => (
                        <motion.div
                            key={product.id}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border border-gray-200"
                        >

                            {/* Image */}
                            <div className="h-64 w-full bg-gray-100 flex items-center justify-center overflow-hidden">
                                <img
                                    src={product.image}
                                    alt={product.name}
                                    className="w-full h-full object-contain hover:scale-110 transition-transform duration-500"
                                />
                            </div>


                            {/* Details */}
                            <div className="p-6">

                                <p className="inline-block text-sm bg-green-50 text-green-600 font-medium px-3 py-1 rounded-full">
                                    {product.category}
                                </p>

                                <h3 className="mt-2 text-lg font-semibold text-gray-900 line-clamp-2">
                                    {product.name}
                                </h3>

                                {/* <p className="mt-2 text-xl font-bold text-green-600">
                                    {product.price}
                                </p> */}

                                <Link
                                    to={`/shop`}
                                    className="block mt-5 text-center border border-green-600 text-green-600 py-2.5 rounded-xl font-medium hover:bg-green-600 hover:text-white transition"
                                >
                                    View Products
                                </Link>

                            </div>

                        </motion.div>
                    ))}
                </div>


                {/* Shop Button */}
                <div className="text-center mt-12">
                    <Link
                        to="/shop"
                        className="bg-green-600 text-white px-8 py-3 rounded-full hover:bg-green-700 transition"
                    >
                        View All Products
                    </Link>
                </div>

            </div>
        </section>
    );
};

export default FeaturedProducts;